<template>
    <div>
        <UserActivity/>
    </div>
</template>

<script>
import UserActivity from '../Users/UserActivity.vue';

export default {
    components: {
        UserActivity
    }
}
</script>